var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitternewlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter_black_background_icon",
    "data-name": "Twitter black background icon",
    transform: "translate(-8265 -3813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_410",
    "data-name": "Ellipse 410",
    transform: "translate(8265 3813)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(8271.295 3819.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    d: "M281.544,167.31l6.978,9.33-7.022,7.586h1.58l6.148-6.641,4.967,6.641h5.378l-7.371-9.855,6.536-7.061h-1.58l-5.662,6.117-4.575-6.117Zm2.324,1.164h2.471l10.91,14.588h-2.471Z",
    transform: "translate(-281.5 -167.31)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitternewlogo);
export default __webpack_public_path__ + "static/media/twitternewlogo.50bfd1883cc4e0ce3686a61261cfe04c.svg";
export { ForwardRef as ReactComponent };